$(function() {
	////////////////////////////
	// navigation
	////////////////////////////
	// hover dropdown menu
	$('.js-gnav li').hover(function(e) {
		$("ul:not(:animated)", this).slideDown({
			duration: 500,
			easing: 'easeOutCubic'
		});
	}, function(e) {
		$(".st-gnav__children", this).slideUp();
	});
	$('.st-gnav__item--has-child > a').on('click', function() {
		return false;
	});

	// sp drawer nav
	$('.drawer').drawer();


	////////////////////////////
	// news list
	////////////////////////////
	$('a', '.js-accordion--newslist').on('click', function(e) {
		e.stopPropagation();
	});
	$('.js-accordion--newslist').on('click', function(e) {
		$(this).toggleClass("_is-open");
		$('._next', this).slideToggle(300);
		return false;
	});


	////////////////////////////
	// cover image
	////////////////////////////
	// masonry
	$('.grid').imagesLoaded(function() {
		$('.grid').masonry({
			// itemSelector: '.item',
			// isFitWidth: true,
			// isAnimated: true
			// use outer width of grid-sizer for columnWidth
			columnWidth: '.grid-sizer',
			// do not use .grid-sizer in layout
			itemSelector: '.grid-item',
			percentPosition: true,
			// gutter: 2
			// resize: false
		});
	});
	// imgをbgimgに変更
	$('.grid--menu').on('layoutComplete', function(event, items) {
		items.forEach(function(item, index) {
			var trg = $(item.element);
			NS.setImgAsBg(trg);
		});
	});

	$('.js-switch-bgimg').each(function(index, element) {
		var trg = $(element);
		NS.setImgAsBg(trg);
	});


	////////////////////////////
	// info list accordion
	////////////////////////////
	$('.js-accordion--article').accordion({
		header: '> header',
		heightStyle: 'content',
		collapsible: true,
		active: false
	});


	////////////////////////////
	// move to anchor
	////////////////////////////
	$('.st-wrap-page a[href^="#"]').click(function() {
		var href = $(this).attr("href");
		var target = $(href == "#" || href == "" ? 'html' : this.hash);
		if (!target.length) return;
		moveToTarget(target, href);
		return false;
	});
	var offsetMap = {
	  "#history" : -200,
	  "#building" : -100,
	  // "#access-car" : -150,
	  // "#access-public" : -150,
	  // "#access-walk" : -150,
	  "default" : -120
	}
	var moveToTarget = function(target, href) {
		var offsetY = (offsetMap[href] == undefined) ? offsetMap.default : offsetMap[href];
		var targetY = target.offset().top + offsetY;
		$('html, body').animate({
			scrollTop: targetY
		}, 500, 'swing');
		// ハッシュ書き換えとく
		if (href != null && href == "#")
			window.history.pushState(null, null, getPlainURL());
		else
			window.history.pushState(null, null, target.selector);
	};

});

